import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CategoriaEditComponent } from '../categoria-edit/categoria-edit.component';
import { load } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class CategoriaComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  cats:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<CategoriaEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnIniciar();
  }

  fnIniciar(){
    this.loading = true;
    this.dataService.getCategorias().subscribe(
                      rows => {   
                              this.cats = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargadas());
  }

  fnCategoriasCargadas(){
    //console.log(this.cats);
    this.loading = false;
  }

  fnEditar(cat){
    //console.log("Editar: " + cat.id);
    let dialogRef = this.dialog.open(CategoriaEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:cat.idCat,
                                            item:cat
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                      //console.log("Popup cerrado");
                                      this.fnIniciar();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(CategoriaEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item:{'grupo': null, 
                                                 'idGpo':null,
                                                 'categoria': null, 
                                                 'descrip': null, 
                                                 'etiqueta': null, 
                                                 'etiqueta2': null, 
                                                 'act': 1}
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                      //console.log("Popup cerrado");
                                      this.fnIniciar();
                                     });                                     
  }

}

